import { IconProps } from '@mdi/react/dist/IconProps';

export const SR_IGNORE_SVG: Partial<IconProps> = {
  ['aria-hidden']: 'true',
};
